import type { Dispatch, GetState } from 'model/State';
import { Query } from 'redux-first-router';

export const ROUTE = 'mac/enable-auto-renew/ROUTE';

export const route = (accountId: string, params?: Query) => ({
  type: ROUTE,
  payload: {
    accountId,
  },
  meta: {
    query: params,
  },
});

export const routeIncludeParams = (accountId: string) => (dispatch: Dispatch, getState: GetState) =>
  dispatch(route(accountId, getState().location.query));
